<template><!-- svgo-optimised -->
<svg class="icon icon__arrow icon__arrow--arrow-drop-right" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)"><path d="m10 17 5-5-5-5v10Z"/></g><defs><clipPath id="a"><path d="M0 0h24v24H0z" /></clipPath></defs></svg>
</template>